module.exports = __webpack_public_path__ + "static/media/scan.4c25e663.pdf";